const DEFAULT_PUBLIC_APP_URL = 'https://6amrun.club';

function appBaseUrl() {
  const configuredUrl = process.env.EXPO_PUBLIC_APP_URL ?? DEFAULT_PUBLIC_APP_URL;
  let end = configuredUrl.length;
  while (end > 0 && configuredUrl[end - 1] === '/') {
    end -= 1;
  }
  return configuredUrl.slice(0, end);
}

export function tenantProfileUrl(tenantSlug: string) {
  return `${appBaseUrl()}/${tenantSlug}`;
}

export function eventDetailsUrl(tenantSlug: string, eventId: string) {
  return `${appBaseUrl()}/${encodeURIComponent(tenantSlug)}/events/${encodeURIComponent(eventId)}`;
}

export function routeShareUrl(shareToken: string) {
  return `${appBaseUrl()}/routes/${encodeURIComponent(shareToken)}`;
}

export function eventShareMessage({
  eventTitle,
  eventWhen,
  placeName,
  tenantName,
  url,
}: Readonly<{
  eventTitle: string;
  eventWhen?: string;
  placeName?: string | null;
  tenantName?: string | null;
  url: string;
}>) {
  const context = [tenantName?.trim(), eventWhen?.trim()].filter(Boolean).join(' · ');

  return [eventTitle.trim(), context, placeName?.trim(), url].filter(Boolean).join('\n');
}
